// Module
var code = "<div class=\"crm-notify\"> <div class=\"icon-container\" render-html-data template=\"{{vm.icon}}\"></div> <div class=\"title\">{{ vm.title }}</div> <div class=\"message\">{{ vm.message }}</div> <div ng-if=\"vm.allowClose\" class=\"btn-container\"> <button ng-click=\"vm.handleModalClose()\">Close</button> </div> </div> ";
// Exports
module.exports = code;